import { ContentState, EditorState } from 'draft-js'
import htmlToDraft from 'html-to-draftjs'

export const switchElements = (
  elements: Array<string>,
  element: string,
  move: 'up' | 'down'
) => {
  const index = elements.indexOf(element)
  const switchIndex = move === 'up' ? index - 1 : index + 1

  const moved = elements[index]
  elements[index] = elements[switchIndex]
  elements[switchIndex] = moved
}

export const disabledMove = (
  elements: Array<string>,
  element: string,
  move: 'up' | 'down',
  initialIndex?: number
) => {
  const index = elements.indexOf(element)
  const switchIndex = move === 'up' ? index - 1 : index + 1

  if (switchIndex < (initialIndex || 0) || switchIndex >= elements.length)
    return true
  return false
}

export const initEditorState = (ranHtml: string) => {
  if (ranHtml === undefined || ranHtml === null)
    return EditorState.createEmpty()
  const contentBlock = htmlToDraft(ranHtml)
  if (contentBlock) {
    const contentState = ContentState.createFromBlockArray(
      contentBlock.contentBlocks
    )
    return EditorState.createWithContent(contentState)
  } else {
    return EditorState.createEmpty()
  }
}
